import { render } from "./item-tariff.vue?vue&type=template&id=570ff47e&scoped=true"
import script from "./item-tariff.vue?vue&type=script&lang=js"
export * from "./item-tariff.vue?vue&type=script&lang=js"

import "./item-tariff.vue?vue&type=style&index=0&id=570ff47e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570ff47e"]])

export default __exports__